module.exports = __webpack_public_path__ + "2b2401183a3d5805e40bef83e499aa97.pdf";